var exports = {
  "jw": "SearchFilterChip.module__chip___M3liUX",
  "xA": "SearchFilterChip.module__chipActive___M3liUX",
  "mD": "SearchFilterChip.module__chipIcon___M3liUX",
  "s5": "SearchFilterChip.module__chipContent___M3liUX",
  "Zl": "SearchFilterChip.module__chipLabel___M3liUX",
  "$j": "SearchFilterChip.module__chipLabelActive___M3liUX",
  "ET": "SearchFilterChip.module__chipValue___M3liUX",
  "cG": "SearchFilterChip.module__chipValueActive___M3liUX",
  "DT": "SearchFilterChip.module__removeButton___M3liUX",
};

module.exports = exports;
